import script from "./ShowMonitoraggioOrizzontale.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowMonitoraggioOrizzontale.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__